import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import CheckMarkWithoutBG from '~/images/shared/CheckMarkWithoutBG.svg';

const FieldsAdditionSuccessModal: React.FC<{
  numberOfFields: number;
}> = ({ numberOfFields }) => {
  const { closeModal } = useModal();
  const { t } = useTranslation('common');

  return (
    <div className='flex flex-col items-center justify-center gap-32 px-32'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-secondary-90 text-green-300'>
        <CheckMarkWithoutBG width='30' height='30' />
      </div>
      <div className=' max-w-sm text-center'>
        <Typography variant='h2' weight='medium'>
          {t('congratulations')}
        </Typography>
        <Typography variant='h2' weight='medium'>
          {t('fields-added', {
            number: numberOfFields,
          })}
        </Typography>
        <Typography className='mt-8 text-surface-10'>
          {t('find-fields-go-to')}
        </Typography>
        <Typography className='mt-8 text-surface-10' weight='bold'>
          {t('settings')} &gt; {t('property')} &gt; {t('fields')}
        </Typography>
      </div>
      <div className='mt-16 flex w-full justify-end'>
        <Button
          onClick={() => {
            closeModal();
            closeModal();
          }}
          size='sm'
          className='h-56 !rounded-xl'
        >
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
};
export { FieldsAdditionSuccessModal };
